import React from "react"

export default function ChevronUp() {
  return (
    <symbol id="svg-chevron-up" viewBox="0 0 26 14">
      <path d="M20.9711 11.6923C21.1905 11.8804 21.4869 11.9874 21.797 11.9905C22.1071 11.9937 22.4063 11.8927 22.6309 11.7091C22.8555 11.5256 22.9876 11.2739 22.9992 11.0079C23.0107 10.7419 22.9007 10.4825 22.6927 10.2851L13.5054 2L4.31736 10.2851C4.10467 10.4819 3.99086 10.7427 4.00058 11.0111C4.01031 11.2794 4.14278 11.5336 4.3693 11.7187C4.59583 11.9038 4.89817 12.0048 5.21083 11.9998C5.52349 11.9949 5.82129 11.8844 6.03973 11.6923L13.5054 4.96062L20.9711 11.6923Z" />
    </symbol>
  )
}
